import EventCategoryModel from "@/models/event/eventCategoryModel";
import EventCategoryUpsertModel from "@/models/event/eventCategoryUpsertModel";
import { apiClient } from "./apiService";
import { AxiosResponse } from "axios";

export default {
  async getAllEventCategorysAsync(): Promise<Array<EventCategoryModel>> {
    const response = await apiClient.get("eventcategory");
    return response.data.map((x: AxiosResponse) => new EventCategoryModel(x));
  },
  async getAllEventCategorysByCalendarAsync(
    calendarId: string
  ): Promise<Array<EventCategoryModel>> {
    const response = await apiClient.get(
      `eventcategory/calendar/${calendarId}`
    );
    return response.data.map((x: AxiosResponse) => new EventCategoryModel(x));
  },
  async getEventCategoryAsync(
    eventcategoryId: string
  ): Promise<EventCategoryModel> {
    const response = await apiClient.get(`eventcategory/${eventcategoryId}`);
    return new EventCategoryModel(response.data);
  },
  async createEventCategory(
    model: EventCategoryUpsertModel
  ): Promise<EventCategoryModel> {
    const response = await apiClient.post(`eventcategory`, model);
    return new EventCategoryModel(response.data);
  },
  async updateEventCategory(
    eventcategoryId: string,
    model: EventCategoryUpsertModel
  ): Promise<EventCategoryModel> {
    const response = await apiClient.put(
      `eventcategory/${eventcategoryId}`,
      model
    );
    return new EventCategoryModel(response.data);
  },
  async deleteEventCategory(eventcategoryId: string): Promise<void> {
    await apiClient.delete(`eventcategory/${eventcategoryId}`);
  }
};
